import React from 'react';
import './CentroConvenzionatoPage.css';

const CentroConvenzionatoPage: React.FC = () => {
  return (
    <div className="centro-convenzionato-page">
      {/* Header Section */}
      <section className="centro-header">
        <div className="centro-header-container">
          <p className="centro-header-label">CONVENZIONE SSN</p>
          <h1 className="centro-header-title">Centro Convenzionato</h1>
          <p className="centro-header-description">
            Prestazioni otorinolaringoiatriche in convenzione con il Sistema Sanitario Nazionale
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="centro-content">
        <div className="centro-content-container">
          <div className="centro-image-container">
            <img 
              src={require("../assets/photos/main-photo.jpg")} 
              alt="Centro Convenzionato"
              className="centro-image"
            />
          </div>

          <div className="centro-info">
            <h2 className="centro-info-title">Prestazioni in Convenzione</h2>
            <ul className="centro-list">
              <li>Prima visita otorinolaringoiatrica</li>
              <li>Visita otorinolaringoiatrica di controllo</li>
              <li>Videoendoscopia delle vie aeree digestive superiori</li>
              <li>Esame audiometrico tonale</li>
              <li>Impedenzometria</li>
              <li>Rimozione di cerume</li>
              <li>Test clinico della funzionalità vestibolare</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Info Box */}
      <section className="centro-info-box">
        <div className="centro-info-box-container">
          <h3>Come Accedere alle Prestazioni in Convenzione</h3>
          <p>
            Per usufruire delle prestazioni in convenzione con il Sistema Sanitario Nazionale, 
            è necessario essere in possesso di impegnativa del medico curante. Contattaci per 
            maggiori informazioni sui tempi di attesa e per prenotare la tua visita.
          </p>
        </div>
      </section>
    </div>
  );
};

export default CentroConvenzionatoPage;
